module.exports = __webpack_public_path__ + "static/media/flamingoDesktop.6d48eef3.svg";